"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiChipProps = void 0;
var react_1 = __importDefault(require("react"));
var RemoveFilled_1 = __importDefault(require("@tdcerhverv/parrotfish/icons/RemoveFilled"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/SvgIcon"));
exports.MuiChipProps = {
    deleteIcon: react_1.default.createElement(SvgIcon_1.default, { component: RemoveFilled_1.default, viewBox: '0 0 48 48' }),
};
